import React from 'react';
import { splitQuestionText } from '../../utils/questionText';
import './QuestionText.css';

/**
 * A question's text. An ordinary question is returned exactly as before (plain text, no
 * extra elements); a question that embeds a table draws that table as a real <table>
 * (scrolls sideways on a phone) with its prose around it.
 */
export default function QuestionText({ text }) {
  const blocks = splitQuestionText(text);
  if (blocks.length === 1 && blocks[0].type === 'text') return <>{blocks[0].text}</>;
  return (
    <>
      {blocks.map((b, i) => (b.type === 'table' ? (
        <div className="q-table-wrap" key={i} role="group" aria-label="Data table" tabIndex={0}>
          <table className="q-table">
            <thead><tr>{b.header.map((h, c) => <th scope="col" key={c}>{h}</th>)}</tr></thead>
            <tbody>
              {b.rows.map((row, r) => (
                <tr key={r}>{row.map((cell, c) => (c === 0 ? <th scope="row" key={c}>{cell}</th> : <td key={c}>{cell}</td>))}</tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <span className="q-text__para" key={i}>{b.text}</span>
      )))}
    </>
  );
}
